import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule)
  .then(() => {
    // aspetta che Angular abbia finito il render iniziale
    setTimeout(() => {
      document.querySelectorAll('[ng-version]').forEach((el) => {
        el.removeAttribute('ng-version');
      });
    });
  })
  .catch(err => console.error(err));
